import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Pagination,
  Stack,
} from "@mui/material";

const QueryChangeLogTable = ({ queryLogs, handlePageClick, pageItemCount, currentPage = 0 }) => {
  const headerCellSx = {
    backgroundColor: (theme) => theme.palette.grey[100],
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: "0.85rem",
    color: "#424242",
    whiteSpace: "nowrap",
  };

  return (
    <Box sx={{ py: 2 }}>
      <TableContainer component={Paper} sx={{ maxHeight: "80vh" }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellSx}>SiteID – SubjectsID</TableCell>
              <TableCell sx={headerCellSx}>Trial Name</TableCell>
              <TableCell sx={headerCellSx}>Visit Name</TableCell>
              <TableCell sx={headerCellSx}>Visit Type</TableCell>
              <TableCell sx={headerCellSx}>Block Name</TableCell>
              <TableCell sx={headerCellSx}>Who Filled It</TableCell>
              <TableCell sx={headerCellSx}>Role</TableCell>
              <TableCell sx={headerCellSx}>Query Requester / Respondent</TableCell>
              <TableCell sx={headerCellSx}>Role</TableCell>
              <TableCell sx={headerCellSx}>Timestamp</TableCell>
              <TableCell sx={headerCellSx}>Action</TableCell>
              <TableCell sx={headerCellSx}>Query Content</TableCell>
              <TableCell sx={headerCellSx}>Query Status</TableCell>
              <TableCell sx={headerCellSx}>Recipients</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {queryLogs?.results?.length > 0 ? (
              queryLogs.results.map((log, index) => (
                <TableRow key={index} hover>
                  <TableCell>{log.site_participant_id}</TableCell>
                  <TableCell>{log.trial_name}</TableCell>
                  <TableCell>{log.visit_name}</TableCell>
                  <TableCell>{log.visit_type}</TableCell>
                  <TableCell>{log.block_name}</TableCell>
                  <TableCell>{log.block_filled_by_email}</TableCell>
                  <TableCell>{log.block_filled_by_role}</TableCell>
                  <TableCell>{log.query_sender_email}</TableCell>
                  <TableCell>{log.query_sender_role}</TableCell>

                  <TableCell>
                    {new Date(log.created_at + "Z").toDateString()}
                    <br />
                    {new Date(log.created_at + "Z").toLocaleTimeString()}
                  </TableCell>

                  <TableCell>{log.action}</TableCell>

                  <TableCell
                    sx={{
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {log.query_content}
                  </TableCell>

                  <TableCell>{log.query_status}</TableCell>
                  <TableCell>{log.recipients}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={14} align="center">
                  <Typography variant="body2" color="text.secondary">
                    No query change logs available
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Stack direction="row" justifyContent="center" sx={{ pt: 2 }}>
        <Pagination
          color="primary"
          page={currentPage + 1}
          count={Math.ceil(queryLogs?.count / pageItemCount)}
          onChange={(_, page) => handlePageClick({ selected: page - 1 })}
        />
      </Stack>
    </Box>
  );
};

export default QueryChangeLogTable;
